import React from "react";
import "./user-name-with-date.scss";
import moment from "moment";

interface UserNameWithDateProps {
  userName: string;
  date: string;
}

export const UserNameWithDate: React.FC<UserNameWithDateProps> = ({ userName, date }) => {
  const formattedDate = moment(date).format("LLL");
  return (
    <span className="c-user-name-with-date">
      {userName} @ {formattedDate}
    </span>
  );
};
